export const truncate = (text, max) => (text.length > max ? `${text.slice(0, max)}...` : text);

export const transformAdsActionCreate = (data) => ({
  ...data,
  params: data.params ? JSON.parse(data.params) : {},
  expected_before: data.expected_before ? JSON.parse(data.expected_before) : null
});
